import { render, staticRenderFns } from "./ListaMetas.vue?vue&type=template&id=f7272d48&scoped=true&"
import script from "./ListaMetas.vue?vue&type=script&lang=js&"
export * from "./ListaMetas.vue?vue&type=script&lang=js&"
import style0 from "./ListaMetas.vue?vue&type=style&index=0&id=f7272d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7272d48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow,VTab,VTabItem,VTabs})
